import { type CSSProperties } from 'react';

import { PAGE_BODY_PADDING } from '../shared/blueprint-view-styles';

export const BACKSPLASH_BODY_STYLE: CSSProperties = {
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	padding: PAGE_BODY_PADDING,
	gap: '48px',
	overflow: 'hidden'
};

export const BACKSPLASH_EMPTY_STYLE: CSSProperties = {
	fontSize: '14px',
	color: '#999',
	margin: 'auto'
};

export const BACKSPLASH_FOOTER_STYLE: CSSProperties = {
	flexShrink: 0,
	display: 'flex',
	flexDirection: 'column',
	gap: '14px'
};
